import { useCallback } from "react";

type UseVideoPlayingHandlerProps = {
  setIsVideoReady: (val: boolean) => void;
};

// Handle when video stream is playing
export function useVideoPlayingHandler({
  setIsVideoReady,
}: UseVideoPlayingHandlerProps) {
  return useCallback(() => {
    setIsVideoReady(true);
  }, [setIsVideoReady]);
}
